(function () {
  const calcMinHeight = () => {
    const facetsTop = document.querySelector('.facets__top');
    const sortWrapper = document.querySelector('.facets__sort-wrapper');

    if (facetsTop) {
      facetsTop.style.minHeight = sortWrapper.getBoundingClientRect().height+'px';
    }
  }

  const resizeCollectionGrid = () => {
		const collectionGridSection = document.querySelector('.collection-grid-section') || document.querySelector('.section-search');

		const sectionResizeObserver = new ResizeObserver((entries) => {

			const [entry] = entries;
      calcMinHeight();
		});

		sectionResizeObserver.observe(collectionGridSection);
	}

  document.addEventListener('shopify:section:load', function () {
		resizeCollectionGrid();
	});

	resizeCollectionGrid();

  const sub_collection = document.querySelector(".sub-collection-list");
  if(sub_collection.scrollWidth > sub_collection.clientWidth){
    sub_collection.classList.add("scroll");
  }
  
  jQuery(document).ready(function($) {
    $('.sub-collection-list.owl-carousel').each((index,item) => {
          $(item).owlCarousel({
              loop:false,
              // rewind: true,
              margin:10,
              nav:true,
              dots: false,
              responsive:{
                      0:{
                              items: 3.2,
                              margin:10
                      },
                      500:{
                              items: 5.5,
                              margin:15
                      },
                      989:{
                              items: 8.5,
                              margin:15
                      }
              }
          })
      })
  });
})();